import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { fetcher } from '~lib/api/fetch';
import { Nullable } from '~types/common';

import QueryKeys from '../queryKeys';

const url = (companyId: string) => `/api/company/${companyId}/financialReport`;

export interface FinancialChartData {
  year: number;
  /** 매출 */
  salesAmount?: Nullable<number>;
  /** 영업이익 */
  operatingIncome: Nullable<number>;
  /** 당기순이익 */
  netIncome: Nullable<number>;
}

interface Response {
  source: string;
  financialReport: Record<string, FinancialChartData[]>;
}

export default function useCompanyFinancialChartData(companyId: string) {
  return useQuery<Response, AxiosError>(
    [QueryKeys.companyFinancialChart, companyId],
    () => fetcher(url(companyId)),
    {
      enabled: !!companyId,
    },
  );
}
